import React from 'react';
import styles from './styles/styles.module.css';

const ProtecteeLog: React.FC = () => {
  return <div className={styles.wrapper}></div>;
};

export default ProtecteeLog;
